import { t } from '@lingui/core/macro';
import { Fragment } from 'react';
import { Modal } from '../ui/Modal';
import Kbd from './Kbd';
import { getShortcutGroups } from './shortcuts';

interface KeyboardShortcutsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function KeyboardShortcutsModal({ isOpen, onClose }: KeyboardShortcutsModalProps) {
  const groups = getShortcutGroups();

  return (
    <Modal.Root
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      ariaLabel={t`Keyboard shortcuts`}
    >
      <Modal.Header title={t`Keyboard shortcuts`} />
      <Modal.Body scrollable>
        <div className="flex flex-col gap-6">
          {groups.map((group) => (
            <section key={group.section}>
              <h3 className="text-copy-secondary mb-2 text-xs font-semibold tracking-wide uppercase">
                {group.title}
              </h3>
              <ul className="flex flex-col gap-1">
                {group.entries.map((entry) => (
                  <li
                    key={entry.description}
                    className="flex items-center justify-between py-1.5"
                  >
                    <span className="text-copy-primary text-sm">{entry.description}</span>
                    <span className="flex items-center gap-1">
                      {entry.keys.map((key, i) => (
                        <Fragment key={i}>
                          <Kbd>{key}</Kbd>
                        </Fragment>
                      ))}
                    </span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </Modal.Body>
    </Modal.Root>
  );
}

export default KeyboardShortcutsModal;
